import { Routes, Route } from 'react-router-dom'
import Layout from './components/layout/Layout'
import { usePageTracking } from './hooks/usePageTracking'

// Pages will be imported here by Phase 3 agents
// IMPORT_PAGES_HERE
import Team from './pages/Team/Team'
import NewsList from './pages/News/NewsList'
import NewsDetail from './pages/News/NewsDetail'
import Home from './pages/Home/Home'
import Project from './pages/Project/Project'
import Contact from './pages/Contact/Contact'
import Gallery from './pages/Gallery/Gallery'
import MentionsLegales from './pages/Legal/MentionsLegales'
import PolitiqueConfidentialite from './pages/Legal/PolitiqueConfidentialite'

// Temporary placeholder page
const PlaceholderPage = ({ title }: { title: string }) => (
  <div style={{ padding: '2rem', textAlign: 'center' }}>
    <h1>{title}</h1>
    <p>Cette page sera créée par les agents Phase 3</p>
  </div>
)

function AppRouter() {
  usePageTracking()

  return (
    <Layout>
      <Routes>
        {/* ROUTES_HERE - Phase 3 agents will add their routes */}
        <Route path="/equipe" element={<Team />} />
        <Route path="/actualites" element={<NewsList />} />
        <Route path="/actualites/:slug" element={<NewsDetail />} />

        {/* Temporary routes - to be replaced */}
        <Route path="/" element={<Home />} />
        <Route path="/le-projet" element={<Project />} />
        <Route path="/galerie" element={<Gallery />} />
        <Route path="/contact" element={<Contact />} />

        {/* Legal pages */}
        <Route path="/mentions-legales" element={<MentionsLegales />} />
        <Route path="/politique-confidentialite" element={<PolitiqueConfidentialite />} />

        <Route path="*" element={<PlaceholderPage title="Page non trouvée" />} />
      </Routes>
    </Layout>
  )
}

export default AppRouter
